<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="ICCID号/虚拟号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getUserBalanceListHandler" clearable></el-input>
            </el-form-item>
			<el-form-item label="开户时间：" >
			    <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
			</el-form-item>
            <el-form-item>
                <el-button type="primary"  @click="getUserBalanceListHandler">搜索查询</el-button>
                 <el-button type="success" @click="showToNewCard1"  plain icon="el-icon-s-ticket">增加余额账户</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border  >
            <el-table-column type="index" label="序号"></el-table-column> 
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column  prop="mobile" label="手机号"></el-table-column>
            <el-table-column  label="账户余额（元）">
                <template slot-scope="scope">
                    {{ scope.row.amount/100 }}
                </template>
            </el-table-column>

            <el-table-column  label="开户时间">
                <template slot-scope="scope">
                    {{dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.createTime))}}
                </template>
            </el-table-column>

            <el-table-column  prop="remark" label="备注"></el-table-column>

            <el-table-column label="操作" width="180" >
                <template slot-scope="scope" >
                    <el-button type="text" size="small" 
                    @click="showChangeBalanceDialog(scope.row.iccid, scope.row.mobile)">修改余额</el-button>

                    <el-button type="text" size="small" @click="resetPassword(scope.row.iccid, scope.row.mobile)" >重置密码</el-button>
                    <el-button type="text" size="small" @click="showTransferBalanceDialog(scope.row)" >转余额</el-button>
                </template>                
            </el-table-column>

        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>



        <el-dialog :append-to-body="true"  title="修改余额" :visible.sync="chgBalanceVisible" width="600px" @close="hideChangeBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="changeBalanceForm" :model="changeBalanceForm" :rules="changeBalanceFormRules" label-width="120px">
                <el-form-item label="iccid：" >
                    <label >{{changeBalanceForm.iccid}}</label>
                </el-form-item>
                <el-form-item label="手机号：" >
                    <label >{{changeBalanceForm.mobile}}</label>
                </el-form-item>
                <el-form-item label="变动类型:" >
                    <el-radio v-model="changeBalanceForm.type" label="1">增加</el-radio>
                    <el-radio v-model="changeBalanceForm.type" label="2">扣减</el-radio>
                </el-form-item>

                <el-form-item label="金额：" prop="amountRmb">
                    <el-input-number v-model="changeBalanceForm.amountRmb"
                    :precision="2" :step="1" :min="0">
                  </el-input-number>
                </el-form-item>

                <el-form-item label="关联单号：" prop="orderNo">
                    <el-input v-model="changeBalanceForm.orderNo" placeholder="请输入关联单号" maxlength="24" show-word-limit clearable></el-input>
                </el-form-item>

                <el-form-item label="备注：" prop="remark">
                    <el-input  type="textarea" v-model="changeBalanceForm.remark" placeholder="请输入内容" rows="3" maxlength="50" show-word-limit clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hideChangeBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="doChangeBalance()">确 定</el-button>
            </div> 
        </el-dialog> 



        <el-dialog :append-to-body="true"  title="转余额" :visible.sync="transferBalanceVisible" width="600px" @close="closeTransferBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="transferBalanceForm" :model="transferBalanceForm" :rules="transferBalanceFormRules" label-width="120px">
                <el-form-item label="旧ICCID：" >
                    <label >{{transferBalanceForm.oldIccid}}</label>
                </el-form-item>

                <el-form-item label="转出金额：" >
                    <label >{{transferBalanceForm.amountRmb/100}}  元</label>
                </el-form-item>

                <el-form-item label="转入卡ICCID/虚拟号：" prop="newIccid">
                    <el-input v-model.trim="transferBalanceForm.newIccid" placeholder="转入卡ICCID" clearable></el-input>
                </el-form-item>


                <el-form-item label="备注：" prop="remark">
                    <el-input  type="textarea" v-model.trim="transferBalanceForm.remark" placeholder="请输入备注" :rows="3" show-word-limit :maxlength="50" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeTransferBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="transferBalanceToOther()">确 定</el-button>
            </div> 
        </el-dialog> 
                 
         <el-dialog :append-to-body="true"  title="增加余额账户" :visible.sync="transferBalanceVisible1" width="600px" @close="closeTransferBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="dataForm" :model="dataForm" :rules="transferBalanceFormRules1" label-width="120px">
          
                <el-form-item label="卡号" prop="iccid">
                    <el-input v-model.trim="dataForm.iccid" placeholder="ICCID或虚拟号" clearable></el-input>
                </el-form-item>
                <el-form-item label="余额/元" prop="amount">
                    <el-input v-model.trim="dataForm.amount" placeholder="输入账户金额" clearable></el-input>
                </el-form-item>
                <el-form-item label="余额密码" prop="payPass">
                    <el-input v-model.trim="dataForm.payPass" placeholder="默认6个0" clearable></el-input>
                </el-form-item>
                   <el-form-item label="绑定手机号" prop="mobile">
                    <el-input v-model.trim="dataForm.mobile" placeholder="非必填" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input  type="textarea" v-model.trim="dataForm.remark" placeholder="请输入备注" :rows="3" show-word-limit :maxlength="50" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeTransferBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="transferBalanceToOther1()">确 定</el-button>
            </div> 
        </el-dialog> 
                 
    </div>
</template>
<script>
import { getUserBalance, resetPwd, changeBalance} from '@/api/record.js'
import common from '@/utils/common.js'
import {mapGetters } from "vuex";
export default {
    data(){

        var checkSalePrice = (rule, value, callback) => {
            if(value.length < 10){
                return callback(new Error('备注不能少于10个字'))
            }
            callback();
        };

        return {
            searchForm: {
                iccid: '',
                orderNo: '',
				time: '',
                payState:null,
            },
             dataForm: {
                iccid: '',
                mobile: '',
				payPass: '',
                remark:null,
                amount:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            //修改余额
            changeBalanceForm: {
                iccid:"",
                mobile:"",
                amountRmb:"",
                type:'1',
                orderNo:'',
                remark:'',
            },

            changeBalanceFormRules: {
                amountRmb: [{required: true, message: '请输入变动金额', trigger: 'blur'}],
                orderNo: [{required: true, message: '请输入关联单号', trigger: 'blur'}],
                remark: [
                    {required: true, message: '请输入备注', trigger: 'blur'},
                    {validator: checkSalePrice, trigger: 'blur'}],
            },

            chgBalanceVisible: false,


            //转余额
            transferBalanceForm: {
                oldIccid:null,
                amountRmb: null,
                newIccid:null,
                remark:null
            },

            transferBalanceFormRules: {
                newIccid:  {required: true, message: '请输入转入卡的ICCID', trigger: 'blur'},
                remark: {required: true, message: '请输入备注', trigger: 'blur'}
            },
            transferBalanceVisible: false,
            transferBalanceVisible1:false,
        }
    },
    methods: {
         transferBalanceToOther1(){
                 common.sysRequest("sysUser/add/account", this.dataForm, 'post').then(res=>{
                            if(res.data.code == 200){
                                this.closeTransferBalanceDialog();
                            this.getUserBalanceListHandler();
                                this.$message.success(res.data.message);
                            }else{
                                this.$message.error(res.data.message)
                            }     
                }).catch(err=> console.error(err));
                   
        },
         showToNewCard1(){
            this.transferBalanceVisible1 = true;
        }, 
        getUserBalanceListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getUserBalance(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })   
        },

        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },


        resetPassword(iccid, mobile){
            this.$confirm('确定要重置密码吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resetPwd({
                    iccid: iccid,
                    mobile: mobile,
                }).then( res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                    }else{
                        this.$message.error(res.data.message);
                    } 
                })
            }).catch(() => {

            });
  
        },

        showChangeBalanceDialog(iccid, mobile){
            this.changeBalanceForm.iccid = iccid;
            this.changeBalanceForm.mobile = mobile;
            this.chgBalanceVisible = true;
        },

        hideChangeBalanceDialog(){
            for (let key in  this.changeBalanceForm) {
                this.changeBalanceForm[key] = '';
            }
            this.changeBalanceForm.type = '1';
            this.chgBalanceVisible = false;
        },


        doChangeBalance(){
            this.$refs.changeBalanceForm.validate(valid => {
                if(valid){
                    this.$confirm('确定要修改余额吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        changeBalance(this.changeBalanceForm).then( res => {
                            if(res.data.code == 200){
                                this.$message.success('余额修改成功');
                                this.getUserBalanceListHandler();
                                this.hideChangeBalanceDialog();
                            }else{
                                this.$message.error(res.data.message);
                            } 
                        })
                    }).catch(() => {

                    });
                }
            });
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getUserBalanceListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getUserBalanceListHandler();
        },

        showTransferBalanceDialog(data){
            this.transferBalanceForm.oldIccid = data.iccid;
            this.transferBalanceForm.amountRmb = data.amount;
            this.transferBalanceVisible = true;
        },
        closeTransferBalanceDialog(data){
            this.transferBalanceVisible = false;
             this.transferBalanceVisible1 = false;
            this.transferBalanceForm = {
                oldIccid:null,
                newIccid:null,
                amountRmb: null,
                remark:null
            };
            this.$refs.transferBalanceForm.resetFields();
        },
        //转余额
        transferBalanceToOther(){
            let data = {
                oldIccid: this.transferBalanceForm.oldIccid,
                newIccid: this.transferBalanceForm.newIccid,
                remark: this.transferBalanceForm.remark
            };

            this.$refs.transferBalanceForm.validate(valid => {
                if(valid){
                    this.$confirm('确定要转余额吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        common.sysRequest("sysUser/user/account/to/other", data, 'post').then(res=>{
                            if(res.data.code == 200){
                                this.closeTransferBalanceDialog();
                                this.getUserBalanceListHandler();
                                this.$message.success(res.data.message);
                            }else{
                                this.$message.error(res.data.message)
                            }     
                        }).catch(err=> console.error(err));
                    }).catch(() => {

                    });
                }
            });

            
        }

    },
    created () {
        
    },

    mounted(){
        let fromPage = this.$store.state.menu.fromPage;
        if(fromPage == 'balanceRechargeRecord'){
            this.searchForm.iccid = this.fromPageIccid;
            this.getUserBalanceListHandler();
            this.$store.commit('menu/setFromPage', '');
            this.$store.commit('menu/setFromPageIccid', '');
        }else{
            this.getUserBalanceListHandler();
        }
    },

    computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

        fromPageIccid: function(){
            return this.$store.state.menu.iccidToAccount;
        },
    },

    watch: {
        fromPageIccid: function () {
            let fromPage = this.$store.state.menu.fromPage;
            if(fromPage == 'balanceRechargeRecord'){
                this.searchForm.iccid = this.fromPageIccid;
                this.getUserBalanceListHandler();
                this.$store.commit('menu/setFromPage', '');
                this.$store.commit('menu/setFromPageIccid', '');
            }
        }
    },
}
</script>
<style lang="less" scoped>

</style>

